export default function WeekRow() {
  return (
    <div className=" font-size12 text-gray7 font-medium ">
      <ul className=" flex justify-around gap-c4">
        <li className="w-calc-7 h-c24 flex justify-center">Su</li>
        <li className="w-calc-7 h-c24 flex justify-center">Mo</li>
        <li className="w-calc-7 h-c24 flex justify-center">Tu</li>
        <li className="w-calc-7 h-c24 flex justify-center">We</li>
        <li className="w-calc-7 h-c24 flex justify-center">Th</li>
        <li className="w-calc-7 h-c24 flex justify-center">Fr</li>
        <li className="w-calc-7 h-c24 flex justify-center">Sa</li>
      </ul>
    </div>
  );
}
